<template>
  <div>
    <w-datepicker :model="schema.updateCurrentDecision.endDate" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz daty końca deecyzji
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
